import styled from "styled-components";

export const TableWrapper = styled.div`
  padding-left: 20px;
  padding-right: 20px;
`;
